import routes from '../../router/routeList';
import receiptIcon from 'assets/receipt.svg';
import client from '../../assets/client.png';
import userIcon from 'assets/user.svg';
import logout from 'assets/logout.svg';
import login from '../../assets/login.png';
import msg from '../../assets/msn.png';
import packageIcon from '../../assets/catalogWithe.png';
import dashboardIcon from '../../assets/dashboard.svg';

export const linksS = [
  { name: 'Resumen', to: routes.summary, icon: dashboardIcon },
  { name: 'Órdenes', to: routes.orders, icon: receiptIcon },
  { name: 'Cotizaciones', to: routes.cotizaciones, icon: receiptIcon },
  { name: 'Perfil', to: routes.profile, icon: userIcon },
  { name: 'Cerrar sesión', to: routes.logout, icon: logout },
];

export const linksGold = [
  { name: 'Resumen', to: routes.summary, icon: dashboardIcon, list: [] },
  { name: 'Órdenes', to: routes.orders, icon: receiptIcon, list: [] },
  { name: 'Cotizaciones', to: routes.cotizaciones, icon: receiptIcon, list: [] },
  { name: 'Catálogo', to: routes.catalog, icon: packageIcon, list: [] },
  { name: 'Clientes', to: routes.customers, icon: client, list: [] },
  { name: 'Mensajes', to: routes.messages, icon: msg, list: [] },
  { name: 'Perfil', to: routes.profile, icon: userIcon, list: [] },
  { name: 'Cerrar sesión', to: routes.logout, icon: logout, list: [] },
];

export const linkOrder = [{ name: 'Iniciar sesión', to: routes.login, icon: login }];
